import { capitalizeEveryWord } from '../string';

const MIN_DESCRIPTION_LENGTH_FROM_API = 70;

const buildStoreOffersTitle = ({ storeName, serverMonth, serverYear }) => {
  const formattedMonth = capitalizeEveryWord(serverMonth || '');

  return `Ofertas ${storeName} em ${formattedMonth} ${serverYear} | Promobit`;
};

const buildStoreOffersH1 = ({ storeName, serverMonth, serverYear }) => {
  const formattedMonth = capitalizeEveryWord(serverMonth || '');

  return `Ofertas ${storeName} em ${formattedMonth} ${serverYear}`;
};

const buildStoreOffersDescription = ({ storeName, offersMetaDescription }) => {
  if (
    typeof offersMetaDescription === 'string' &&
    offersMetaDescription.length >= MIN_DESCRIPTION_LENGTH_FROM_API
  ) {
    return offersMetaDescription;
  }

  return `Encontre ofertas ${storeName} no Promobit. Promoções verificadas pela comunidade e atualizadas diariamente, com os melhores preços do dia.`;
};

/**
 * Returns the HTML snippet that should be fed to the FAQ parser, or `null`
 * when no FAQ should be emitted.
 *
 * Three scenarios:
 *  - Store follows the named-section convention AND has <h2>FAQ</h2>:
 *    parse only the FAQ section.
 *  - Store follows the convention but lacks <h2>FAQ</h2>: return null.
 *    Scanning the whole blob would leak <h3>?</h3> patterns from other
 *    sections (Sobre/Contato/Outras) into FAQPage as false-positive items.
 *  - Legacy store (no named sections recognized): parse the whole blob.
 */
export const selectFaqHtml = ({ sections, sourceHtml, hasNamedSections }) => {
  if (hasNamedSections && !sections?.faq) {
    return null;
  }

  return sections?.faq || sourceHtml || null;
};

export const getStoreOffersMeta = ({
  storeName,
  serverMonth,
  serverYear,
  offersMetaDescription = null,
}) => ({
  title: buildStoreOffersTitle({ storeName, serverMonth, serverYear }),
  description: buildStoreOffersDescription({
    storeName,
    offersMetaDescription,
  }),
  h1Text: buildStoreOffersH1({ storeName, serverMonth, serverYear }),
});
